<template>
  <article class="nebraska-myday-lottery-play-slip-item-skeleton w-full flex flex-col items-center">
    <LcCard shadow="none">
      <div class="play flex flex-col items-center gap-150 px-200">
        <header class="text-center">
          <h4 class="text-h4">
            {{ $t('lottery.nebraskamydaylottery.playslip.selector.headline') }}
          </h4>
          <p>
            {{ $t('lottery.nebraskamydaylottery.playslip.selector.message') }}
          </p>
        </header>

        <LcCard class="w-full container">
          <div class="-m-200 flex flex-col items-center">
            <ul class="w-full flex">
              <li v-for="i in [1, 2, 3]" :key="i" class="play py-100 w-full flex justify-center">
                <LcSkeleton height="10.375rem" width="3rem" />
              </li>
            </ul>
          </div>
        </LcCard>

        <LcSkeleton class="mt-md" height="3rem" width="12.5rem" />
      </div>
    </LcCard>
  </article>
</template>

<style lang="scss" scoped>
.nebraska-myday-lottery-play-slip-item-skeleton {
  .play {
    position: relative;
    width: 100%;
    max-width: 22.5rem;
  }
}
</style>
